import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import CkoAccessKeysForm from './CkoAccessKeysForm';
import SilaNavTabs from '../common/SilaNavTabs';

function ThirdPartyApiKeys({ appId, admin = false, onSave }) {
  const { t } = useTranslation();
  const tabs = [
    {
      key: 'cko',
      label: t('applications.buttons.cko'),
      component: <CkoAccessKeysForm appId={appId} onSave={onSave} admin={admin} />,
    },
  ];
  return <SilaNavTabs tabs={tabs} defaultTab="cko" />;
}

ThirdPartyApiKeys.propTypes = {
  /**
   * The id of the application
   */
  appId: PropTypes.number.isRequired,
  /**
   * The admin toggle to determine if the form is used for the admin console
   */
  admin: PropTypes.bool,
  /**
   * The function to be called when the application is saved
   */
  onSave: PropTypes.func.isRequired,
};

export default ThirdPartyApiKeys;
